<template>
    <Fragment>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <tr v-for="lancamento in lancamentos" :key="lancamento.id">
            <td v-if="showDetailIcon">
                <b-icon 
                    v-if="lancamento.situacaoSaldo"
                    icon="check-circle" 
                    type="is-success" 
                    v-tippy 
                    :title="$t('aprovado')"
                />

                <b-icon 
                    v-else
                    icon="close-circle" 
                    type="is-danger" 
                    v-tippy 
                    :title="$t('bloqueado')"
                />
            </td>
            <td>{{ lancamento.idVenFlexLancamentoErp }}</td>
            <td>{{ $moment(lancamento.dataHora).format("HH:mm") }}</td>
            <td>
                <router-link
                    v-if="lancamento.idPedido"
                    :to="{
                        name: 'ven-pedido-edit',
                        params: {
                            id: lancamento.idPedido,
                            origem: lancamento.origem
                        },
                        query: { from: 'flex-detail', id: $route.params.id },
                    }"
                >
                    {{
                        lancamento.nomeLancamento
                            ? $t(lancamento.nomeLancamento, {
                                  idPedido: lancamento.idPedido,
                                  origem: lancamento.origem,
                              })
                            : "--"
                    }}
                </router-link>
                <span v-else
                    >{{
                        lancamento.nomeLancamento
                            ? $t(lancamento.nomeLancamento, {
                                  idPedidoRetorno: lancamento.idPedidoRetorno,
                                  idFatura: lancamento.idFatura,
                                  origem: lancamento.origem,
                              })
                            : "--"
                    }}
                </span>
            </td>
            <td>{{ lancamento.criadoPor ? lancamento.criadoPor : "--" }}</td>
            <td>
                {{
                    lancamento.nomeMotivo
                        ? lancamento.nomeMotivo
                        : $t("automatico-sistema")
                }}
            </td>
            <td>{{ lancamento.observacao ? lancamento.observacao : "--" }}</td>
            <td>{{ lancamento.tipo ? lancamento.tipo : "--" }}</td>
            <td :class="{ 'is-debit': lancamento.saldoGerado < 0 }">
                {{
                    new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }).format(
                        lancamento.saldoGerado ? lancamento.saldoGerado : 0
                    )
                }}
            </td>
            <td :class="{ 'is-debit': lancamento.saldoLiberado < 0 }">
                {{
                    new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }).format(
                        lancamento.saldoLiberado ? lancamento.saldoLiberado : 0
                    )
                }}
            </td>
        </tr>
        <tr>
            <td></td>
            <td colspan="9" class="py-0">
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </td>
        </tr>
    </Fragment>
</template>

<script>
import FlexLancamentoService from "@/services/vendas/financeiro/FlexLancamentoService.js";
import ContainerLoader from "@/components/content/loader/ContainerLoader.vue";
import { Fragment } from "vue-frag";

export default {
    name: "DetalhesMovimentacao",
    components: {
        ContainerLoader,
        Fragment,
    },
    props: {
        dataHora: {
            type: String,
            default: "",
        },
        isMobile: {
            type: Function,
            default: () => {},
        },
        sortTable: {
            type: Function,
            default: () => {},
        },
        sharedFilters: {
            type: Object,
            default: () => {},
        },
    },
    watch: {
        sharedFilters: {
            handler: function () {
                this.carregarDados();
            },
            deep: true,
        },
    },
    created() {
        this.filters.dataHora = this.dataHora;

        this.carregarDados();
    },
    data() {
        return {
            service: new FlexLancamentoService(this.$http, this.$router),
            lancamentos: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            filters: {
                dataHora: null,
                currentPage: 1,
                perPage: 10,
            },
            showDetailIcon: true,
            isLoading: false,
        };
    },
    methods: {
        resetPagination() {
            this.pagination.resetPagination = true;
            this.pagination.currentPage = 1;
            this.pagination.perPage =
                this.pagination.perPageOptions[this.pagination.optionStarted];

            this.filters.currentPage = 1;
            this.filters.perPage =
                this.pagination.perPageOptions[this.pagination.optionStarted];

            this.carregarDados(1);
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;

            this.filters.perPage = value.perPage;
            this.filters.currentPage = value.currentPage;

            this.carregarDados(value.currentPage);
        },
        carregarDados() {
            this.isLoading = true;

            const movimentacaoDetalheFilters = {
                ...this.sharedFilters,
                ...this.filters,
            };

            this.service
                .findAllItensTotal(movimentacaoDetalheFilters)
                .then(({ content, totalElements }) => {
                    this.lancamentos = content;

                    this.pagination.totalRows = totalElements;
                })
                .catch((error) => {
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-overflow {
        .table {
            min-width: 990px;
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.is-debit {
    color: #f44336;
}
.g-2 {
    gap: 8px;
}
// Barra de filtro
.label-situacao {
    position: absolute;
    bottom: 5px;
    top: 5px;
    display: flex;

    .bar {
        border-radius: 100px;
        width: 5px;
        min-height: 25px;
        height: 100%;
        &.bar-finalizada {
            background-color: #84bd42;
        }
        &.bar-aberta {
            background-color: #fd5858;
        }
    }
}
.sovis-tag {
    display: inline-block;
    text-transform: capitalize;
    text-align: center;
    font-size: 11px;
    padding: 3px 5px;
    border-radius: 4px;
    color: #fff;
    margin: 1px;
    cursor: pointer;

    &.is-success {
        background-color: $green-alert;
    }
    &.is-danger {
        background-color: $orange;
    }
}
.sovis-container-user {
    cursor: pointer;
    padding: 2px 10px;
    border: solid 1px $primary-color;
    background-color: #f0f0f0;
    border-radius: 6px;
    display: flex;
    position: absolute;
    @media screen and (max-width: 850px) {
        position: relative;
    }
    .qtd-users {
        font-weight: bolder;
        font-size: 18px;
        margin: 0 10px;
        &.is-success {
            color: $green-alert;
        }
        &.is-danger {
            color: $orange;
        }
    }
}
</style>
